import { render, staticRenderFns } from "./PendingAuthNotifications.vue?vue&type=template&id=628146bb&"
import script from "./PendingAuthNotifications.vue?vue&type=script&lang=js&"
export * from "./PendingAuthNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports